import axiosClient, { app_uri } from "../../../utils/axiosFactory";
import { PrivacyClient } from "../../parentApi";

const client = new PrivacyClient(app_uri, axiosClient());

export default client;
